import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Badge,
  Nav,
  Table,
  ListGroup,
  Spinner,
} from "react-bootstrap";
import Member from "../../models/Member";
import { useParams } from "react-router-dom";
import Palette from "../../Palette";
import { Link } from "react-router-dom";
import moment from "moment";

export default function MitraProfilePage() {
  const modelMember = new Member()
  const { id } = useParams()
  const [loading, setLoading] = useState(false)
  const [mitraSwastaData, setMitraSwastaData] = useState(null)
  const [activeTab, setActiveTab] = useState("informasi");

  const fetchMitraSwasta = async () => {
    try {
      setLoading(true)
      const result = await modelMember.getMitraSwastaActiveByID(id)
      setMitraSwastaData(result)
    } catch (errr) {
      console.error('errr', errr)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchMitraSwasta()
  }, [])


  if (loading) {
    return (
      <Container className="my-5 d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
        <Spinner animation="border" role="status" style={{ color: Palette.PRIMARY }}>
        </Spinner>
      </Container>
    )
  }

  if (!mitraSwastaData) {
    return (
      <Container className="my-5 d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
        <p>Data tidak ditemukan</p>
      </Container>
    )
  }

  return (
    <Container className="my-5 d-flex justify-content-center">
      <div style={{ maxWidth: "900px", width: "100%" }}>
        <Card className="p-4 shadow-sm mb-3">
          <Row className="align-items-center">
            <Col xs={3} className="d-flex justify-content-center">
              <img
                src={mitraSwastaData.profile_picture_url || '/no-image-placeholder.jpg'}
                alt={mitraSwastaData.full_name}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = '/no-image-placeholder.jpg';
                }}
                style={{ width: "100px", height: "100px", objectFit: "contain" }}
              />
            </Col>

            <Col xs={9}>
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="fw-bold text-primary mb-1">{mitraSwastaData.full_name || '-'}</h5>
                <Badge
                  bg="light"
                  text="primary"
                  className="border border-primary rounded-pill"
                >
                  {Member.getEntityLabel(mitraSwastaData.mitra_entity)} | Mitra Swasta
                </Badge>
              </div>

              <p className="text-muted mb-2">
                {[
                  mitraSwastaData.address_locality,
                  mitraSwastaData.address_region,
                  'Indonesia'
                ].filter(Boolean).join(', ')}
              </p>

              {mitraSwastaData.mitra_website && (
                <Button
                  href={mitraSwastaData.mitra_website}
                  target="_blank"
                  style={{
                    backgroundColor: Palette.PRIMARY,
                    border: "none",
                    borderRadius: "8px",
                    padding: "8px 14px",
                    fontWeight: "500",
                  }}
                >
                  Kunjungi Situs Web Resmi
                </Button>
              )}
            </Col>
          </Row>
        </Card>

        {/* Tabs */}



        <Card className="p-4 shadow-sm mb-3">
          {/* <h6 className="fw-bold mb-3">Informasi Umum</h6> */}


          {mitraSwastaData.mitra_vision && (
            <div className="mb-3">
              <div dangerouslySetInnerHTML={{ __html: mitraSwastaData?.about_me || '' }} />
            </div>
          )}
          {/* Vision */}
          {mitraSwastaData.mitra_vision && (
            <div className="mb-3">
              <h6 className="fw-bold" style={{ fontSize: "14px" }}>Visi</h6>
              <p style={{ fontSize: "14px" }}>{mitraSwastaData.mitra_vision}</p>
            </div>
          )}

          {/* Mission */}
          {mitraSwastaData.mitra_mission && (
            <div className="mb-3">
              <h6 className="fw-bold" style={{ fontSize: "14px" }}>Misi</h6>
              <p style={{ fontSize: "14px" }}>{mitraSwastaData.mitra_mission}</p>
            </div>
          )}

          <Table bordered responsive size="sm" className="mt-3" style={{ fontSize: "14px" }}>
            <tbody>
              <tr>
                <td style={{ fontWeight: "bold", width: "200px" }}>
                  Bergabung Sejak
                </td>
                <td>{moment(mitraSwastaData.approval_date).isValid() ? moment(mitraSwastaData.approval_date).format('YYYY') : '-'}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>Bentuk Badan Usaha</td>
                <td>{Member.getEntityLabel(mitraSwastaData.mitra_entity)}</td>
              </tr>

              <tr>
                <td style={{ fontWeight: "bold", width: "200px" }}>
                  Tahun Berdiri
                </td>
                <td>{mitraSwastaData.mitra_year_founded || '-'}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>Alamat</td>
                <td>
                  {[
                    mitraSwastaData.address_street,
                    mitraSwastaData.address_locality,
                    mitraSwastaData.address_region,
                    mitraSwastaData.address_postal
                  ].filter(Boolean).join(', ') || '-'}
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>Email</td>
                <td>
                  {mitraSwastaData.email ? (
                    <a href={`mailto:${mitraSwastaData.email}`}>{mitraSwastaData.email}</a>
                  ) : '-'}
                </td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>No Telepon</td>
                <td>{mitraSwastaData.phone_number || '-'}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>Situs Web Resmi</td>
                <td>
                  {mitraSwastaData.mitra_website ? (
                    <a
                      href={mitraSwastaData.mitra_website}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {mitraSwastaData.mitra_website}
                    </a>
                  ) : '-'}
                </td>
              </tr>
            </tbody>
          </Table>
        </Card>

        {/* Services and Resources */}
        <Card className="p-4 shadow-sm mb-3">
          <h6 className="fw-bold text-primary mb-3">Layanan yang Ditawarkan</h6>
          {mitraSwastaData.mitra_services && Object.keys(mitraSwastaData.mitra_services).filter(key => mitraSwastaData.mitra_services[key]).length > 0 ? (
            <ul style={{ fontSize: "14px" }}>
              {Object.entries(mitraSwastaData.mitra_services)
                .filter(([_, value]) => value === true)
                .map(([key, _]) => (
                  <li key={key}>{Member.getServiceLabel(key)}</li>
                ))}
            </ul>
          ) : (
            <p style={{ fontSize: "14px" }}>Tidak ada layanan terdaftar</p>
          )}
        </Card>

        {/* Resources */}
        <Card className="p-4 shadow-sm mb-3">
          <h6 className="fw-bold text-primary mb-3">Sumber Daya</h6>
          <Table bordered responsive size="sm" style={{ fontSize: "14px" }}>
            <tbody>
              <tr>
                <td style={{ fontWeight: "bold", width: "200px" }}>Jumlah Penerjemah</td>
                <td>{mitraSwastaData.mitra_resource_translator || 0}</td>
              </tr>
              <tr>
                <td style={{ fontWeight: "bold" }}>Jumlah Juru Bahasa</td>
                <td>{mitraSwastaData.mitra_resource_intrepater || 0}</td>
              </tr>
            </tbody>
          </Table>
        </Card>

        {(mitraSwastaData?.mitra_resource_has_referance === 1 && mitraSwastaData?.mitra_resource_reference && mitraSwastaData.mitra_resource_reference.length > 0) && (
          <Card className="p-4 shadow-sm mb-3">
            <h6 className="fw-bold text-primary mb-3">Anggota HPI di Dalam Tim</h6>
            <Table bordered responsive size="sm" style={{ fontSize: "14px" }}>
              <tbody>
                <tr>
                  <td style={{ fontWeight: "bold" }}>Nama Anggota</td>
                  <td style={{ fontWeight: "bold" }}>Nomor Anggota HPI</td>
                </tr>
                {mitraSwastaData.mitra_resource_reference.map((ref, index) => (
                  <tr>
                    <td>{ref.full_name}</td>
                    <td style={{ cursor: 'pointer' }}>
                      <Link to={`/anggota/${ref.hpi_id}`}>{ref.hpi_id}</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card>
        )}

        {mitraSwastaData.mitra_attachment_portofolio?.length > 0 && (
          <Card className="p-4 shadow-sm">
            <h6 className="fw-bold text-primary mb-3">Portofolio</h6>
            <ListGroup variant="flush">
              {mitraSwastaData.mitra_attachment_portofolio.map((file, idx) => (
                <ListGroup.Item key={idx}>
                  <a style={{ color: '#000', fontSize: '0.85rem' }} href={file.url} target="_blank" rel="noreferrer">
                    {`Lihat Portofolio ${mitraSwastaData.mitra_attachment_portofolio?.length > 1 ? idx + 1 : ''}`}
                  </a>
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Card>
        )}

      </div>
    </Container>
  );
}
